/**
 * Enumeration defining different types of chat messages for proper filtering
 * in multi-tab environments.
 */
export enum MessageType {
  /**
   * System messages that should appear in all tabs (health checks, connection status, etc.)
   */
  SYSTEM = 'SYSTEM',

  /**
   * User-initiated conversation messages that should be filtered by tab
   */
  CONVERSATION = 'CONVERSATION',

  /**
   * User input messages
   */
  USER = 'USER'
}

/**
 * Type guard to check if a string is a valid MessageType
 */
export function isValidMessageType(value: string): value is MessageType {
  return Object.values(MessageType).includes(value as MessageType);
}

/**
 * Default message type for messages without explicit type
 */
export const DEFAULT_MESSAGE_TYPE = MessageType.CONVERSATION;